import React, { useState, useEffect } from "react";
import {
    CardContent,
    Container,
    Grid,
    Paper,
    Modal,
    Button,
    Typography,
    makeStyles,
    useTheme,
} from "@material-ui/core";
import price_range_course from "../assets/ad/popup/price_range_course.png";

const useStyles = makeStyles((theme) => ({
    header: {
        fontSize: 50,
        fontWeight: 'bold',
    },
    banner: {
        backgroundSize: 'cover',
        color: 'white',
    },
    title: {
        fontSize: 36,
        fontWeight: 'bold',
    },
    description: {
        fontSize: 18,
    },
    enrollButton: {
        marginTop: theme.spacing(2),
    },
    modalContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%', // Responsive width
        maxWidth: '400px', // Maximum width for larger screens
        height: '80vh', // Responsive height
        backgroundColor: 'white',
        padding: theme.spacing(2), // Add Material-UI spacing
    },
    iframeContainer: {
        width: '100%',
        height: '100%',
        // overflow: 'auto', // Enable vertical scrolling
    },
    iframe: {
        width: '100%', // Set the width to be wider than the container
        height: '100%',
        // overflowX: 'auto', // Enable horizontal scrolling
        border: 'none', // Remove iframe border
    },
}));

const courses = [
    { id: 1, name: "MEAN stack development" },
    { id: 2, name: "MERN stack development" },
    { id: 3, name: "CS 101" },
];

const mockAPI = {
    students: [
        { id: 1, name: "John Doe", email: "john@example.com", courses: [1, 3] },
        { id: 2, name: "Jane Smith", email: "jane@example.com", courses: [2] },
    ],
};

const pageStyle = {
    backgroundColor: "#f6f6f6",
    padding: "20px",
};

const formContainerStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
};

function Course() {
    const [user, setUser] = useState(null);
    const [formData, setFormData] = useState({ name: "", email: "", mobile: "" });
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [students, setStudents] = useState(mockAPI.students);
    const [emailError, setEmailError] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [nameError, setNameError] = useState("");
    const classes = useStyles();
    const theme = useTheme();
    const [dialogOfCourse, setDialogOfCourse] = useState(true);

    const handleHideDialogOfCourse = () => {
        setDialogOfCourse(false);
    };

    const handleShowDialogOfCourse = () => {
        setDialogOfCourse(true);
    };

    useEffect(() => {
        // Simulate user authentication (you can replace this with your own authentication logic)
        const authenticatedUser = { id: 123, name: "Demo User" };
        setUser(authenticatedUser);
    }, []);

    const [openCS101, setOpenCS101] = useState(false);

    const handleOpenCS101 = () => {
        setOpenCS101(true);
    };

    const handleCloseCS101 = () => {
        setOpenCS101(false);
    };

    const [openMERN, setOpenMERN] = useState(false);

    const handleOpenMERN = () => {
        setOpenMERN(true);
    };

    const handleCloseMERN = () => {
        setOpenMERN(false);
    };

    const [openMEAN, setOpenMEAN] = useState(false);

    const handleOpenMEAN = () => {
        setOpenMEAN(true);
    };

    const handleCloseMEAN = () => {
        setOpenMEAN(false);
    };

    const [openIoT, setOpenIoT] = useState(false);

    const handleOpenIoT = () => {
        setOpenIoT(true);
    };

    const handleCloseIoT = () => {
        setOpenIoT(false);
    };

    const backgroundImageMEAN = "https://aptechludhiana.com/wp-content/uploads/2021/08/mean-stack-banner.png";
    const bannerStyleMEAN = {
        backgroundImage: `url(${backgroundImageMEAN})`, // Dynamic background image URL
        padding: theme.spacing(16),
    };
    const backgroundImageMERN = "https://www.creativeitinstitute.com/images/course/course_1662795698.jpg";
    const bannerStyleMERN = {
        backgroundImage: `url(${backgroundImageMERN})`, // Dynamic background image URL
        padding: theme.spacing(25),
    };
    const backgroundImageCS101 = "https://d3f1iyfxxz8i1e.cloudfront.net/courses/course_image/12f5e1d68fd0.png";
    const bannerStyleCS101 = {
        backgroundImage: `url(${backgroundImageCS101})`, // Dynamic background image URL
        padding: theme.spacing(35),
    };
    return (
        <div >
            <span>
                {dialogOfCourse && (
                    <dialog
                        className="price_range_course_dialog"
                        justify="flex-end"
                        style={{
                            position: 'center',
                            width: '50%',
                            height: 'auto'
                        }}
                        open
                        onClick={handleHideDialogOfCourse}
                    >
                        <img
                            className="image"
                            justify="flex-end"
                            style={{
                                position: 'center',
                                width: '100%',
                                height: 'auto'
                            }}
                            src={price_range_course}
                            onClick={handleHideDialogOfCourse}
                            alt="price_range_course image"
                        />
                    </dialog>
                )}
            </span>
            <div style={pageStyle}>
                <Grid container>
                    <Grid item xs={12} md={6} lg={6} xl={3} justify="flex-end">
                        <Container maxWidth="md">
                            <Typography variant="h1"  style={{ color: "#356D7F", fontWeight: 'bold' }} gutterBottom>Learn to <del>Code</del> Develop APPS</Typography>
                            <Button variant="contained"
                                style={{ backgroundColor: "#356D7F", color: "white"  }}
                                onClick={handleShowDialogOfCourse}>
                                Show Fees
                            </Button>
                            <div><br></br></div>
                            <Typography variant="h3"  style={{ color: "#356D7F", fontWeight: 'bold' }} gutterBottom>
                                🚀  Deep Dive into MEAN Stack Development!
                            </Typography>
                            <div><br></br></div>
                            <Button variant="contained" style={{ backgroundColor: "#356D7F", color: "white" }} onClick={handleOpenMEAN}>
                                Show Syllabus
                            </Button>
                            <Button ><a href="#bookaslot">Book A Slot</a></Button>
                            <Modal
                                open={openMEAN}
                                onClose={handleCloseMEAN}
                                aria-labelledby="embedded-frame-modal"
                                aria-describedby="embedded-frame"
                            >
                                <div className={classes.modalContainer} style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, height: 400, backgroundColor: 'white', padding: '1rem' }}>
                                    <div className={classes.iframeContainer}>
                                        <iframe
                                            title="Embedded Frame"
                                            width="100%"
                                            height="100%"
                                            src="https://docs.google.com/document/d/1Jz0JE-uYp7fddyBWSrn9xelIpch9mXMcxpztf69ltXs/view?embedded=true" // Replace with your URL
                                            frameBorder="0"
                                            allowFullScreen
                                        />
                                    </div>
                                </div>
                            </Modal>

                            <CardContent>
                                <Typography variant="body1" className={classes.description} paragraph>
                                    🚀 Elevate Your Web Development Skills with MEAN Stack Development!
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    Ready to dive into the world of full-stack web development? MEAN Stack Development, our immersive course, is your gateway to mastering the MEAN stack and building modern web applications.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    In this course, you'll explore the MEAN stack, which combines MongoDB, Express.js, Angular, and Node.js. Whether you're a frontend enthusiast or a backend wizard, MEAN Stack Development empowers you to create dynamic and data-driven web applications.
                                </Typography>

                                <Typography variant="h5" className={classes.title} style={{ color: "#356D7F" }} gutterBottom>
                                    Course Highlights:
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    1. <strong style={{ color: "#356D7F" }}>Master MongoDB:</strong> 🗄️ Learn to work with MongoDB, a leading NoSQL database, and harness its power to manage and store data efficiently.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    2. <strong style={{ color: "#356D7F" }}>Express Your Creativity:</strong> 🚀 Dive into Express.js and build robust backend APIs and services for your web applications.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    3. <strong style={{ color: "#356D7F" }}>Create Dynamic UIs with Angular:</strong> 🅰️ Master Angular, a powerful frontend framework, to craft dynamic user interfaces and engaging user experiences.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    4. <strong style={{ color: "#356D7F" }}>Server-side JavaScript with Node.js:</strong> 🚀 Harness the capabilities of Node.js to develop server-side logic and handle real-time communication.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    5. <strong style={{ color: "#356D7F" }}>Full-Stack Development:</strong> 🛠️ Seamlessly integrate all MEAN components to create end-to-end web applications.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    6. <strong style={{ color: "#356D7F" }}>Deployment and Hosting:</strong> 🌐 Learn how to deploy and host your MEAN stack applications on the web for the world to see.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    7. <strong style={{ color: "#356D7F" }}>Build Real Projects:</strong> 🏗️ Apply your knowledge by developing real-world web applications and projects.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    MEAN Stack Development isn't just about learning; it's about crafting web solutions that make an impact. Whether you aim to be a full-stack developer, a web app architect, or a tech entrepreneur, this course is your ticket to success.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    Join us in MEAN Stack Development and unlock your potential in full-stack web development. Embrace the MEAN stack and be ready to create cutting-edge web applications. Enroll now and embark on your journey to MEAN stack mastery!
                                </Typography>
                            </CardContent>
                        </Container>
                        <div><br /></div>
                        <Container maxWidth="md">
                            <Typography variant="h3"  style={{ color: "#356D7F", fontWeight: 'bold' }} gutterBottom>
                                🚀 Deep Dive into MERN Stack Development!
                            </Typography>
                            <div><br></br></div>
                            <Button variant="contained" style={{ backgroundColor: "#356D7F", color: "white"  }} onClick={handleOpenMERN}>
                                Show Syllabus
                            </Button>
                            <Button ><a href="#bookaslot">Book A Slot</a></Button>
                            <Modal
                                open={openMERN}
                                onClose={handleCloseMERN}
                                aria-labelledby="embedded-frame-modal"
                                aria-describedby="embedded-frame"
                            >
                                <div className={classes.modalContainer} style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, height: 400, backgroundColor: 'white', padding: '1rem' }}>
                                    <div className={classes.iframeContainer}>
                                        <iframe
                                            title="Embedded Frame"
                                            width="100%"
                                            height="100%"
                                            src="https://docs.google.com/document/d/1upbJeDsJgv-wV3rVTvgsUVTfV-kc5pRRBkOuE791o3U/view?usp=sharing?embedded=true" // Replace with your URL
                                            frameBorder="0"
                                            allowFullScreen
                                        />
                                    </div>
                                </div>
                            </Modal>
                            <CardContent>
                                <Typography variant="body1" className={classes.description} paragraph>
                                    🚀 Unlock the World of Web Development with MERN Stack Development!
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    Ready to embark on an exciting journey into the world of full-stack web development? MERN Stack Development, our comprehensive course, is your gateway to mastering the MERN stack and building powerful web applications.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    In this immersive course, you'll dive deep into the MERN stack, consisting of MongoDB, Express.js, React, and Node.js. Whether you're passionate about frontend design or backend logic, MERN Stack Development empowers you to create modern, responsive, and dynamic web applications.
                                </Typography>

                                <Typography variant="h5" className={classes.title} style={{ color: "#356D7F" }} gutterBottom>
                                    Course Highlights:
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    1. <strong style={{ color: "#356D7F" }}>Master MongoDB:</strong> 🗄️ Learn to work with MongoDB, a leading NoSQL database, and leverage it for efficient data management.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    2. <strong style={{ color: "#356D7F" }}>Express Your Creativity:</strong> 🚀 Explore Express.js and build robust backend APIs and services for your web applications.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    3. <strong style={{ color: "#356D7F" }}>Create Interactive UIs with React:</strong> ⚛️ Master React, a powerful frontend library, to craft engaging user interfaces and dynamic web experiences.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    4. <strong style={{ color: "#356D7F" }}>Server-side JavaScript with Node.js:</strong> 🚀 Utilize Node.js to develop server-side logic and handle real-time communication.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    5. <strong style={{ color: "#356D7F" }}>Full-Stack Integration:</strong> 🛠️ Seamlessly integrate MongoDB, Express.js, React, and Node.js to create end-to-end web applications.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    6. <strong style={{ color: "#356D7F" }}>Deployment and Hosting:</strong> 🌐 Learn how to deploy and host your MERN stack applications on the web for global access.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    7. <strong style={{ color: "#356D7F" }}>Build Real Projects:</strong> 🏗️ Apply your knowledge by developing practical web applications and projects.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    MERN Stack Development isn't just about learning; it's about creating innovative web solutions that have a real impact. Whether you aspire to be a full-stack developer, a frontend design expert, or a tech entrepreneur, this course equips you with the skills to succeed.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    Join us in MERN Stack Development and unlock your potential in full-stack web development. Embrace the MERN stack and start building cutting-edge web applications today. Enroll now and embark on your journey to MERN stack mastery!
                                </Typography>
                            </CardContent>
                        </Container>
                        <div><br /></div>
                        <Container maxWidth="md">
                            <Typography variant="h3"  style={{ color: "#356D7F", fontWeight: 'bold' }} gutterBottom>
                                🚀 Introduction to Computer Science (CS101)
                            </Typography>
                            <div><br></br></div>
                            <Button variant="contained" style={{ backgroundColor: "#356D7F", color: "white"  }} onClick={handleOpenCS101}>
                                Show Syllabus
                            </Button>
                            <Button ><a href="#bookaslot">Book A Slot</a></Button>
                            <Modal
                                open={openCS101}
                                onClose={handleCloseCS101}
                                aria-labelledby="embedded-frame-modal"
                                aria-describedby="embedded-frame"
                            >
                                <div className={classes.modalContainer} style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, height: 400, backgroundColor: 'white', padding: '1rem' }}>
                                    <div className={classes.iframeContainer}>
                                        <iframe
                                            title="Embedded Frame"
                                            width="100%"
                                            height="100%"
                                            src="https://docs.google.com/document/d/1kE1t8FZXnKvQ_uwGkpBav8fUppTPaPC9rjHjcdJ8tOg/view?usp=sharing?embedded=true" // Replace with your URL
                                            frameBorder="0"
                                            allowFullScreen
                                        />
                                    </div>
                                </div>
                            </Modal>

                            <CardContent>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    🔓 Unlock the World of Computing Excellence with CS101!
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    Are you ready to embark on an exhilarating journey into the heart of computer science? CS101, our Introduction to Computer Science course, is your key to unlocking the boundless possibilities of the digital age.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    In this exciting course, you will discover the fundamental concepts, tools, and techniques that underpin the modern world of technology. Whether you're a seasoned coder or a complete novice, CS101 is designed to empower you to excel in the digital landscape.
                                </Typography>

                                <Typography variant="h5" className={classes.title} style={{ color: "#356D7F" }} gutterBottom>
                                    Course Highlights:
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    1. <strong style={{ color: "#356D7F" }}>Foundations of Coding:</strong> Learn to speak the language of computers through hands-on programming. We'll guide you through the basics of coding and help you build a strong foundation for any programming language you choose to master.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    2. <strong style={{ color: "#356D7F" }}>Problem Solving:</strong> Gain essential problem-solving skills that will make you a problem-solving champion not only in computer science but in everyday life. Tackle real-world challenges and develop elegant, efficient solutions.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    3. <strong style={{ color: "#356D7F" }}>Algorithmic Thinking:</strong> Explore the fascinating world of algorithms – the secret sauce behind every software and app. You'll design, analyze, and optimize algorithms, sharpening your logical thinking.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    4. <strong style={{ color: "#356D7F" }}>Data Structures:</strong> Dive deep into the data structures that power everything from search engines to social networks. Understand how to organize and manipulate data efficiently.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    5. <strong style={{ color: "#356D7F" }}>Software Development:</strong> Step into the shoes of a software developer and learn how to create applications that can change the world. This is where your creativity shines, and your projects come to life.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    6. <strong style={{ color: "#356D7F" }}>Cybersecurity Awareness:</strong> Equip yourself with knowledge about digital security, protecting yourself and others in our interconnected world.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    7. <strong style={{ color: "#356D7F" }}>Ethical Computing:</strong> Explore the moral and ethical considerations of technology. Learn how to use your newfound powers for good and make responsible digital choices.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    CS101 is not just about learning; it's about transformation. Whether you aspire to be a programmer, a tech entrepreneur, a data scientist, or simply a more informed digital citizen, this course will empower you to reach your goals.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    Join us in CS101 and be part of the digital revolution. Don't just use technology – become a creator of it. Enroll now and embark on your journey to computer science greatness!
                                </Typography>
                            </CardContent>
                        </Container>
                        <div><br /></div>
                        <Container maxWidth="md">
                            <Typography variant="h3"  style={{ color: "#356D7F", fontWeight: 'bold' }} gutterBottom>
                                🚀 IoT with Rasperry Pi
                            </Typography>
                            <div><br></br></div>
                            <Button variant="contained" style={{ backgroundColor: "#356D7F", color: "white"  }} onClick={handleOpenIoT}>
                                Show Syllabus
                            </Button>
                            <Button ><a href="#bookaslot">Book A Slot</a></Button>
                            <Modal
                                open={openIoT}
                                onClose={handleCloseIoT}
                                aria-labelledby="embedded-frame-modal"
                                aria-describedby="embedded-frame"
                            >
                                <div className={classes.modalContainer} style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, height: 400, backgroundColor: 'white', padding: '1rem' }}>
                                    <div className={classes.iframeContainer}>
                                        <iframe
                                            title="Embedded Frame"
                                            width="100%"
                                            height="100%"
                                            src="https://docs.google.com/document/d/1-0sgs27gW91AphwmLuqkinnLI1w4RbcqID3e6pZXjzM/view?usp=sharing?embedded=true" // Replace with your URL
                                            frameBorder="0"
                                            allowFullScreen
                                        />
                                    </div>
                                </div>
                            </Modal>

                            <CardContent>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    🔓 Unlock the Power of Raspberry Pi! Join Our Course Today!
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                Explore, Learn, Create with Raspberry Pi Programming! 
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                Embark on a journey into the heart of technology with our "Raspberry Pi Programming with Networking and OS Concepts" course! Unleash your creativity and develop real-world skills as you dive into the world of Raspberry Pi, Python programming, networking, and cutting-edge IoT technologies.                                </Typography>

                                <Typography variant="h5" className={classes.title} style={{ color: "#356D7F" }} gutterBottom>
                                    Course Highlights:
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    1. <strong style={{ color: "#356D7F" }}>Raspberry Pi Essentials:</strong> Set up and boot your Raspberry Pi with ease. Understand the components and unleash the potential of this powerful microcomputer.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    2. <strong style={{ color: "#356D7F" }}>Linux Fundamentals:</strong> Master essential command-line operations.
                                    Navigate the file system like a pro.
                                    Edit and manipulate files using nano and vim.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    3. <strong style={{ color: "#356D7F" }}>Python Programming Mastery:</strong> Dive into Python syntax, variables, and data types.
                                    Build control structures and modular programs.
                                    Elevate your programming skills with input/output operations.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    4. <strong style={{ color: "#356D7F" }}>GPIO Magic:</strong> Control LEDs, read input from buttons, and create exciting GPIO-based projects.                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    5. <strong style={{ color: "#356D7F" }}>Networking Wonders:</strong> Configure network settings on Raspberry Pi effortlessly.
                                    Grasp IP addresses, subnetting, and DHCP concepts.
                                    Tackle hands-on networking projects with confidence.                                
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    6. <strong style={{ color: "#356D7F" }}>Remote Access and Protocols:</strong> Access your Raspberry Pi remotely with SSH.
                                    Explore networking protocols like TCP and UDP.
                                    Create your own client-server application.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    7. <strong style={{ color: "#356D7F" }}>MQTT Unleashed:</strong> Discover the power of MQTT in IoT applications.
                                    Set up an MQTT broker on your Raspberry Pi.
                                    Develop MQTT-based applications with Python.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                    7. <strong style={{ color: "#356D7F" }}>OS Concepts Demystified:</strong> Understand processes, threads, and memory management on Raspberry Pi.
                                    Apply OS concepts to enhance your projects.
                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                Embrace the future of technology with hands-on learning. Elevate your skills and open doors to endless possibilities.                                </Typography>

                                <Typography variant="body1" className={classes.description} paragraph>
                                🚀 Why Wait? Join the Revolution! Enroll Now and Shape Your Digital Future!                                </Typography>
                            </CardContent>
                        </Container>
                    </Grid>
                    <Grid item xs={12} md={6} lg={5} xl={9} id="bookaslot">
                        <Container maxWidth="md">
                            <Container maxWidth="md">
                                <Typography variant="h6" style={{ color: "#356D7F", fontWeight: "bold" }}>
                                    Kindly Book Your Slots Here.
                                </Typography>
                                <Paper elevation={3} style={formContainerStyle}>
                                    <Grid container spacing={3}>
                                        <iframe src="https://forms.gle/cpFFD7teNfaVp2xK7?embedded=true" width="640" height="600" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>

                                    </Grid>
                                </Paper>
                            </Container>
                        </Container>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}

export default Course;
